import { Injectable } from '@angular/core';
import { environment } from 'mapfre-auditweb/src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { map, mergeMap } from 'rxjs/operators';
import * as _ from 'lodash';
import { JobsService } from 'mapfre-auditlib';
import { Observable, of, forkJoin } from 'rxjs';
import { FileService, CacheService } from 'mapfre-auditlib';
import { ActivityService } from '../activity/activity.service';

@Injectable({
  providedIn: 'root'
})
export class PaiService {

  className = 'PaiService'
  constructor(private http: HttpClient, private fileService: FileService,private jobsService: JobsService, private activityService: ActivityService, private cacheService: CacheService) { }

  getPAI(id: Number = null, cache = true, cacheKey = "getPaiId") {
    let params = {}
    if (id) {
      cacheKey = cacheKey+"_"+id.toString()
      params = {
        paiId: id
      }
    }

    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable =  this.http.get(environment.base_URL + '/pais', { params }).pipe(map<any[], any>(res => {
      let filtrado = _.find(res, (item => { return item.idPai == id }));
      this.cacheService.updateCacheData(filtrado, cacheKey)
      return filtrado;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  getPaiActive() {
    return of([
      { name: 'FILTERS.YES', value: 1 },
      { name: 'FILTERS.NO', value: 0 }
    ]);
  }

  deletePai(id) {
    return this.http.delete(environment.base_URL + `/pais/${id}`);
  }
  // Hacer otra llamada al mismo endpoint con la lista de estructuras; devuelve lista 
  getPAIByAllOS(filtersback: any = null,ids:any[] = [], detail: any = null, financialYear: any = null, namePai) {
    let params: any = {}
    if (ids) {
        params.organizationalStructureID = ids.join(',') //llega un array
      if (detail) {
        params.organizationalStructureIdDetail = detail;
      }
      if (financialYear) {
        params.financialYear = financialYear.join(','); // lo que llega aqui es un array de años
      }
      if (namePai){
        params.name = namePai
      }
      if(filtersback){
        params.size = filtersback.size;
        params.page = filtersback.page;
      }
    }
    return this.http.get(environment.base_URL + '/filtered-pais', { params });
  }

  getPAIByOs(id: Number = null, detail: any = null, financialYear: any = null) {
    let cache = true
    let cacheKey = "paiByOs"
    let params: any = {}
    if (id) {
      cacheKey = cacheKey+"_"+id.toString()
      params = {
        organizationalStructureID: id
      }
      if (financialYear) {
        cacheKey = cacheKey+"_"+financialYear.toString()
        params.financialYear = financialYear.join(','); // lo que llega aqui es un array de años
      }
      if (detail) {
        cacheKey = cacheKey+"_"+detail.toString()
        params.organizationalStructureIdDetail = detail;
      }
    }

    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable =  this.http.get(environment.base_URL + '/pais', { params }).pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  //!NO se usa
  getAllPAI() {
    return this.http.get(environment.base_URL + `/pais`);
  }

  savePAI(form): Observable<any[]> {
    return this.http.post<any[]>(environment.base_URL + "/pais", form);
  }

  savePaiPostFiles(form): Observable<any> {
    const jobs = _.get(form, 'job');
    const activities = _.get(form, 'activities');
    form.job = [];
    form.activities = [];
    return this.savePAI(form).pipe(mergeMap((result: any) => {
      if (result) {
        if (jobs && jobs.length > 0) {
          jobs.forEach(job => {
            job.pais.forEach(p => {
              p.idPai = result;
            })
          });

          return this.jobsService.addJobListWithFiles(jobs).pipe(mergeMap(resultJobs => {
            if (activities && activities.length > 0) {
              activities.forEach(activity => {
                delete activity['uuid'];
                activity.paiId = result;
              });

              return this.activityService.addActivityListWithFiles(activities);
            }
            else {
              return of(result);
            }
          }));
        }
        else if (activities && activities.length > 0) {
          activities.forEach(activity => {
            activity.paiId = result;
            delete activity['uuid'];
          });

          return this.activityService.addActivityListWithFiles(activities);
        }
        else {
          return of(result);
        }
      }
      else {
        return of(result);
      }



    }));
  }
  savePaiWithFiles(form): Observable<any> {
    let filesToUpload = _.remove(_.get(form, 'documents'), (f) => f instanceof File);
    if (!_.isEmpty(filesToUpload)) { // si no se sube archivo
      return this.savePaiPostFiles(form).pipe(mergeMap((res: any) => {
        let observables = _.map(filesToUpload, (f) => this.fileService.upload(f, 'pai', res)); //se sube el archivo
        return forkJoin(observables).pipe(map(resultFiles => {
          return res;// devuelve los resultados con las 3 llamadas.
        }));
      }))
    }
    else {
      return this.savePaiPostFiles(form);// si no, simplemente realiza la funcion de manera normal.
    }
  }
}
